<template>
	<div>
		<v-layout wrap py-4 px-3>
			<v-flex xs12 px-2>
				<v-radio-group class="radio-filter-by" v-model="model.flagCostCenter">
					<v-radio
						color="cyan"
						label="Todos"
						:value="null"
					></v-radio>
					<!--<v-radio
						color="cyan"
						label="Asientos de costos"
						:value="0"
					></v-radio>-->
				</v-radio-group>
				<v-divider></v-divider>
			</v-flex>
			<v-flex xs12 px-2>
				<span class="caption">Número de Asiento</span>
				<BaseInput
					:height="32"
					v-model="model.code"
				/>
			</v-flex>
			<v-flex xs12 px-2>
				<span class="caption">Número de Documento</span>
				<BaseInput
				:height="32"
					v-model="model.documentId"
				/>
			</v-flex>
			<v-flex xs12 px-2 mb-2>
				<span class="caption">Origen del asiento</span>
				<BaseSelect
					item-text="name"
					item-value="id"
					return-object
					:height="32"
					:items="modules"
					v-model="model.typeRegisterId"
					@input="getValueRegister($event)"
				/>
			</v-flex>
			<v-flex xs12 px-2 mb-2>
				<span class="caption">Estado</span>
				<BaseSelect
					item-text="name"
					item-value="id"
					:height="32"
					:items="states"
					v-model="model.status"
				/>
			</v-flex>
			<v-flex xs12 px-2 mb-2>
				<span class="caption">Tipo de Asiento</span>
				<BaseSelect
					item-text="name"
					item-value="id"
					:height="32"
					:items="typesModule"
					v-model="model.square"
					@input="getData($event)"
				/>
			</v-flex>
			<v-flex xs12 px-2 mb-2>
				<span class="caption">Fechas</span>
				<BaseSelect
					item-text="name"
					item-value="id"
					:height="32"
					:items="typesDate"
					@input="getDataDate($event)"
				/>
			</v-flex>
			<v-flex xs6 px-2 v-if="flagDate">
				<span class="caption">Fecha desde</span>
				<date-component
				round
				:date="model.startDate"
				icon="/static/img/calendar.svg"
				@on-input="getDate({ model: 'startDate', value: $event })"
			></date-component>
			</v-flex>
			<v-flex xs6 px-2 v-if="flagDate">
				<span class="caption">Fecha hasta</span>
				<date-component
					round
					:date="model.endDate"
					icon="/static/img/calendar.svg"
					@on-input="getDate({ model: 'endDate', value: $event })"
				></date-component>
			</v-flex>
		</v-layout>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				successText="Aceptar"
				@cancel-button-clicked="$emit('close-modal')"
				@accept-button-clicked="filterValidate"
			/>
		</section>
	</div>
</template>

<script>
	import { endOfMonth, format, isAfter, subDays } from 'date-fns';
	import { mapGetters } from 'vuex';
	import appDateSelect from '@/components/shared/app-date-select';
	import dateComponent from '@/components/autocomplete/date-component';

	function created() {
		this.loadModules();
		// this.setData();
		this.model.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
		this.model.endDate = this.$today;
		this.model.documentId = null;
	}

	function filterValidate() {
		const invalid = isAfter(this.model.startDate, this.model.endDate);
		if (invalid) {
			this.showNotification('La fecha hasta debe ser igual o mayor a la fecha desde.',
				'info');
		} else {
			this.model.endDate = this.model.endDate ? format(this.model.endDate, 'YYYY-MM-DD') : null;
			this.model.startDate = this.model.startDate ? format(this.model.startDate, 'YYYY-MM-DD') : null;
			this.$emit('filter-by', this.model);
		}
	}

	async function loadModules() {
		const params = { subsidiaryId: this.subsidiaryId };
		({ data: this.modules } = await this.$http.get('type-register', { params }));
		// const index = this.modules.findIndex(m => m.id === this.typeRegisterId);
		// this.model.typeRegisterId = index > -1 ? this.typeRegisterId : null;
	}

	function onDate(value, modelName) {
		this.model[modelName] = value;
	}

	function getValueRegister(module) {
		this.model.typeRegisterId = module;
	}

	function setData() {
		this.model.code = this.code || null;
		this.model.flagCostCenter = this.flagCostCenter;
		this.model.status = this.status || null;
		this.model.endDate = this.endDate || null;
		this.model.startDate = this.startDate || null;
	}

	function getDate({ value, model }) {
		if (model === 'startDate') {
			this.model[model] = format(value, 'YYYY-MM-DD');
			this.model.endDate = format(endOfMonth(value), 'YYYY-MM-DD');
		} else if (model === 'endDate') {
			this.model[model] = format(value, 'YYYY-MM-DD');
		}
	}
	function getData(val) {
		this.model.square = val;
	}

	function getDataDate(val) {
		if (val === 1) {
			this.model.startDate = this.$today;
			this.model.endDate = this.$today;
			this.flagDate = false;
		} else if (val === 2) {
			this.model.startDate = format(subDays(this.$today, 1), 'YYYY-MM-DD');
			this.model.endDate = format(subDays(this.$today, 1), 'YYYY-MM-DD');
			this.flagDate = false;
		} else if (val === 3) {
			this.model.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
			this.model.endDate = this.$today;
			this.flagDate = false;
		} else if (val === 4) {
			const today = new Date(this.$today);
			const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
			this.model.startDate = firstDayOfMonth.toISOString().split('T')[0];
			this.model.endDate = this.$today;
			this.flagDate = false;
		} else if (val === 5) {
			const today = new Date(this.$today);
			// Set the startDate to the first day of the current year
			const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
			this.model.startDate = firstDayOfYear.toISOString().split('T')[0];
			this.model.endDate = this.$today;
			this.flagDate = false;
		} else if (val === 6) {
			this.model.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
			this.model.endDate = this.$today;
			this.flagDate = true;
		}
	}

	function subsidiaryId() {
		return this.currentSubsidiary.id;
	}

	function data() {
		return {
			model: {
				code: null,
				endDate: null,
				flagCostCenter: null,
				startDate: null,
				typeRegisterId: null,
				status: null,
				square: null,
				documentId: null,
			},
			modules: [],
			flagDate: false,
			typesModule: [
				{ id: 1, name: 'Cuadrados' },
				{ id: 2, name: 'No Cuadrados' },
			],
			typesDate: [
				{ id: 1, name: 'Hoy' },
				{ id: 2, name: 'Ayer' },
				{ id: 3, name: 'Ultima Semana' },
				{ id: 4, name: 'Mes Actual' },
				{ id: 5, name: 'Año Actual' },
				{ id: 6, name: 'Rangos de Fechas' },
			],
		};
	}

	export default {
		name: 'journal-filter-by',
		components: {
			BaseInput: () => import('@/components/shared/inputs/base-input'),
			BaseSelect: () => import('@/components/shared/inputs/base-select'),
			BaseDate: () => import('@/components/shared/inputs/base-date'),
			appDateSelect,
			dateComponent,
		},
		computed: {
			...mapGetters('subsidiary', [
				'currentSubsidiary',
			]),
			subsidiaryId,
		},
		created,
		data,
		methods: {
			filterValidate,
			loadModules,
			getData,
			getDataDate,
			getDate,
			onDate,
			setData,
			getValueRegister,
		},
		props: {
			code: [Number, String],
			endDate: [Date, String, Number],
			flagCostCenter: Number,
			startDate: [Date, String, Number],
			typeRegisterId: [Number, String],
			status: [Number, String],
			states: {
				type: Array,
				default: () => [],
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/journal/journal-filter-by.vue